import { render, staticRenderFns } from "./ShareTokenCardSkeleton.vue?vue&type=template&id=3e3b4dec"
import script from "./ShareTokenCardSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShareTokenCardSkeleton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports